import '../styling/global.css';
import img from '../assets/JSKM Logo.webp';
import img1 from '../assets/1.webp';
import img2 from '../assets/2.webp';
import img3 from '../assets/5.webp';
import img4 from '../assets/4.webp';
import img5 from '../assets/3.webp';
import img6 from '../assets/6.webp';
import home1 from '../assets/home1.webp';
import home2 from '../assets/home2.webp';
import home3 from '../assets/home3.webp';
import home4 from '../assets/home4.webp';
import home5 from '../assets/home5.webp';
import home6 from '../assets/home6.webp';
import BackgroundEffect from '../components/BackgroundEffect';
import React, { useEffect, useState } from 'react';

const textBlocks = [
  {
    title: '"Ultimate experience with story,\n emotion and purpose"',
    description:
      'JSKM Technologies is a full-service provider and offers both standardized and individual\nsolutions for its customers\' data-oriented projects implementations.',
  },
  {
    title: '"We work with the motto of providing\n the depth of the research in time"',
    description:
      'We hire talented people who have skills in languages, Research and AI technology\n to provide in-depth analysis for our services. Our jobs empower you with the experience of working\n on projects for cutting-edge IT & Non- IT companies.',
  },
  {
    title: '"Strategy, creativity\n and innovative!"',
    description:
      'JSKM Technologies services are powered by outsourcing, the most exciting and present\n rapidly growing business concept for today’s business world.',
  },
];

const images = [img1, img2, img3, img4, img5, img6];
const repeatedImages = [...images, ...images, ...images, ...images];

const images1 = [home1, home2, home3, home4, home5, home6];
const repeatedImages1 = [...images1, ...images1, ...images1, ...images1];

const Home = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % textBlocks.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <main className="home">
      <BackgroundEffect />

      <section className="hero-section">
        <img src={img} alt="website_logo" className="hero-image" />

        <div className="text-block-wrapper">
          {textBlocks.map((block, index) => (
            <div
              key={index}
              className={`text-block fade ${index === currentIndex ? 'visible' : ''}`}
            >
              <h1>{block.title}</h1>
              <p>{block.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="scrolling-images">
        <div className="image-track">
          {[...repeatedImages, ...repeatedImages].map((img, index) => (
            <img src={img} alt={`scroll-img-${index}`} key={index} className="scroll-image" />
          ))}
        </div>
      </section>

      <section className="info-section">
        <p>
          JSKM Technologies Private Limited in 2025, we are a future-ready technology and talent solutions company dedicated to building smarter, more connected digital experiences for businesses around the world.
          With over 16 years of expertise, we deliver reliable, scalable, and cost-effective technology solutions that empower organizations to grow, innovate, and transform.
        </p>
        <h2 className='content-heading'>Our Story</h2>
        <p>
          Over the years, JSKM Technologies has evolved through dedication, transparency, and practicality — serving a diverse range of clients across industries.
          Our journey began in 2008, when Mr. Jangam Vazrakar, then a student at NIT Jalandhar, envisioned providing web-based information and outsourcing services to help organizations grow through technology. What started as a small proprietary venture — JSK Technologies — grew into a trusted name in IT and research-driven solutions.
          With the experience gained over the years, we established JSKM Technologies Private Limited in 2025, expanding globally and introducing innovative platforms like TrustMee and Wedoo.
          Our continued success for over 16+ years stands as a testament to our passion and perseverance. We believe in our dream and consistently strive to reach out to you — our most valued partner in progress.
          At JSKM Technologies, it’s an honor for our team to serve your business with dedication and excellence. We’re here to show — and make you believe in — our commitment to innovation and your success.
        </p>

         <h2>Our Motto</h2>
        <p>
         “We work with the motto of providing the depth of the research in time.”
        </p>

         <h2>Our Mission</h2>
        <p>
         Empowering organizations through exceptional talent, technology, and innovation.
        </p>

        <h2>Our Products</h2>
        <ul>
          <li><strong>TrustMee:</strong> A global verification app that helps people confirm the authenticity of products purchased online, fostering trust between consumers and brands.</li>
          <li><strong>Wedoo:</strong> A next-generation collaboration and productivity platform that enables teams to connect, create, and work smarter together.</li>
        </ul>
        <p>These innovations reflect our purpose — to build technology that inspires trust, efficiency, and transformation across the world.</p>

        <h2 className='content-heading'>We Empower People and Businesses</h2>
        <p>
          At JSKM Technologies, we hire talented professionals skilled in languages, research, and AI technologies to deliver in-depth analysis and intelligent solutions across industries.
          Our roles empower individuals with the experience of working on projects for leading IT and Non-IT companies, giving them hands-on exposure to innovation and real-world impact.
        </p>

        <h1 className='centered-text'>Our Services</h1>
        <h2>Tailored Expertise Across Domains</h2>
        <p>We provide high-performance resources and solutions in:</p>
        <ul>
          <li><strong>Language & Content Services:</strong> Multilingual experts for translation, content creation, localization, and communication support.</li>
          <li><strong>AI, ML & Research Solutions:</strong> In-depth academic, market, and technical research powered by AI-based methodologies.</li>
          <li><strong>IT Development & Consulting:</strong> Web/mobile development, UI/UX, cloud integration, and digital transformation.</li>
          <li><strong>Data Analytics & Insights:</strong> Turning raw data into actionable insights for smarter, data-driven decisions.</li>
        </ul>
        <p>We combine human intelligence with AI to create smarter, faster, and more personalized solutions.</p>

        <h1 className='centered-text'>How You Can Work With Us</h1>
        <h2>Hire a Resource or a Team – Hourly or Project-Based</h2>
        <ul>
          <li><strong>Hourly Resource Hiring:</strong> Ideal for short-term projects, support, or concept testing.</li>
          <li><strong>Project-Based Engagements:</strong> Dedicated teams for full-cycle development or research.</li>
          <li><strong>Long-Term Resource Allocation:</strong> Seamlessly integrate skilled professionals into your workflows.</li>
        </ul>
        <p>We offer rapid onboarding, minimal admin overhead, and guaranteed productivity.</p>

        <h2>Why It Works:</h2>
        <ul>
          <li> Save up to 60% in operational costs</li>
          <li> 2 Rapid onboarding & minimal admin overhead</li>
          <li> 24/7/365 skilled workforce</li>
          <li> Guaranteed productivity & transparency</li>
        </ul>

        <h1 className='centered-text'>Why JSKM Technologies?</h1>
        <h2>Your Success Is Our Business</h2>
        <ul>
          <li><strong>Cost-Efficient:</strong> Reduce operational costs by up to 60%</li>
          <li><strong>Always Available:</strong> 24/7/365 workforce for global coverage</li>
          <li><strong>Highly Skilled Talent:</strong> Handpicked, domain-expert professionals</li>
          <li><strong>Custom Solutions:</strong> Tailored to your goals and industry</li>
          <li><strong>Quick Turnaround:</strong> Faster delivery without compromising quality</li>
          <li><strong>Trusted Partner:</strong> Transparent processes & consistent results</li>
        </ul>

        <h2>Our Unique Edge</h2>
        <p><strong>Beyond Services – We Create Impact</strong></p>
        <ul>
          <li><strong>With Story:</strong> Every project has a meaningful narrative.</li>
          <li><strong>With Emotion:</strong> We care deeply about user experience and results.</li>
          <li><strong>With Purpose:</strong> Every solution is aligned to real business outcomes.</li>
        </ul>
        <p>We ensure your content, technology, and people deliver the right message to the right audience at the right time.</p>

        <h2>Trusted Across Industries</h2>
        <p>We've successfully supported clients in:</p>
        <ul>
          <li>Logistics & Supply Chain</li>
          <li>Healthcare & Life Sciences</li>
          <li>Education & E-learning</li>
          <li>Finance & Insurance</li>
          <li>E-commerce & Retail</li>
          <li>IT Services & SaaS</li>
        </ul>
        <p>From startups to enterprises, our flexible model fits businesses of all sizes.</p>
      </section>
      <section className="scrolling-images">
        <div className="image-track">
          {[...repeatedImages1, ...repeatedImages1].map((img, index) => (
            <img src={img} alt={`scroll-img-${index}`} key={index} className="scroll-image" style={{ marginBottom: "3.2rem" }} />
          ))}
        </div>
      </section>
    </main>
  );
};

export default Home;
